const finderBtn = document.getElementById("spf-finder-btn");
const finder = document.getElementById("spf-finder");

const question = document.getElementById("finder-question");
const options = document.getElementById("finder-options");
const result = document.getElementById("finder-result");

let answers = {};

/* OPEN */
finderBtn.onclick = () =>{
  finder.style.display="flex";
  startFinder();
};

/* CLOSE */
document.getElementById("finder-close").onclick = ()=>{
  finder.style.display="none";
};

/* START */
function startFinder(){
  resetUI();
  question.innerText="What type of sunscreen are you looking for?";

  showOptions([
    {label:"Face Sunscreen", icon:"🧴"},
    {label:"Body Sunscreen", icon:"✨"}
  ], handleCategory);
}

/* RESET */
function resetUI(){
  options.innerHTML="";
  result.innerHTML="";
}

/* OPTIONS */
function showOptions(list, callback){
  options.innerHTML="";

  list.forEach(item=>{
    const card=document.createElement("div");
    card.className="finder-card";

    card.innerHTML=`
      <div class="card-icon">${item.icon}</div>
      <div class="card-text">${item.label}</div>
    `;

    card.onclick=()=>callback(item.label);
    options.appendChild(card);
  });
}

/* CATEGORY */
function handleCategory(ans){
  answers.category = ans;

  if(ans==="Face Sunscreen"){
    askPurpose();
  }

  if(ans==="Body Sunscreen"){
    askBody();
  }
}

/* PURPOSE */
function askPurpose(){
  resetUI();
  question.innerText="What is the purpose of this sunscreen?";

  showOptions([
    {label:"Everyday Use", icon:"☀️"},
    {label:"Sports", icon:"🏃"},
    {label:"Pigmentation", icon:"🌿"},
    {label:"Sensitive Skin", icon:"🌸"},
    {label:"Anti Ageing", icon:"⏳"},
    {label:"Skip Foundation", icon:"💄"}
  ], handlePurpose);
}

function handlePurpose(ans){
  answers.purpose = ans;
  askSkin();
}

/* SKIN TYPE */
function askSkin(){
  resetUI();
  question.innerText="Select your skin type";

  showOptions([
    {label:"Dry", icon:"🌵"},
    {label:"Oily", icon:"💧"},
    {label:"Sensitive", icon:"🌸"},
    {label:"Combination", icon:"⚖️"}
  ], handleSkin);
}

/* FINAL LOGIC */
function handleSkin(ans){
  answers.skin = ans;

  showMagicScreen(() => {

    const purpose = answers.purpose;
    const skin = answers.skin;

    /* DIRECT MATCHES */

    if(purpose==="Sports"){
      showProduct("Heliocare 360º Sport Transparent Stick Spf 50+","/collections/skin-care/products/heliocare-360%C2%BA-sport-transparent-stick-spf-50/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
      return;
    }

    if(purpose==="Pigmentation"){
      showProduct("Heliocare 360º Pigment Solution Fluid SPF 50+","/collections/skin-care/products/pigment-solution-fluid-spf-50/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
      return;
    }

    if(purpose==="Anti Ageing"){
      showProduct("Heliocare 360º Age Active Fluid SPF 50","/collections/skin-care/products/age-active-fluid-spf-50/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
      return;
    }

    if(purpose==="Sensitive Skin"){
      showProduct("Heliocare 360º Mineral Tolerance Fluid","/collections/skin-care/products/heliocare-mineral-tolerance-fluid/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
      return;
    }

    if(purpose==="Skip Foundation"){
      showProduct("Heliocare Color Gel Cream SPF 50","/collections/skin-care/products/heliocare-color-gel-cream-spf-50/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
      return;
    }

    /* EVERYDAY LOGIC */

    if(purpose==="Everyday Use"){

      if(skin==="Oily"){
        showProduct("Heliocare 360º Gel Oil-Free SPF 50","/collections/skin-care/products/gel-oil-free-spf-50/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
      } else {
        showProduct("Heliocare 360º Water Gel SPF 50+","/collections/skin-care/products/heliocare-360-water-gel-spf-50-50-ml/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
      }

    }

  });
}

/* BODY FLOW */
function askBody(){
  resetUI();
  question.innerText="Choose your body sunscreen";

  showOptions([
    {label:"Everyday Protection", icon:"☀️"},
    {label:"Glow + SPF", icon:"✨"}
  ], handleBody);
}

function handleBody(ans){

  showMagicScreen(() => {

    if(ans==="Everyday Protection"){
      showProduct("Heliocare Advanced Spray SPF 50","/collections/skin-care/products/heliocare-advanced-spray-spf-50/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
    } 
    else {
      showProduct("Heliocare 360º Body Glow Sunscreen","/collections/skin-care/products/heliocare-360-body-glow-sunscreen/?utm_source=find-my-sunscreen&utm_medium=chatbot&utm_url={{page_url}}");
    }

  });
}

/* MAGIC SCREEN */
function showMagicScreen(callback){

  resetUI();

  question.innerHTML = `
    <div class="magic-container">

      <div class="magic-wand">🪄</div>

      <div class="magic-sparkles">
        <span>✨</span>
        <span>✨</span>
        <span>✨</span>
      </div>

      <div style="font-size:16px;font-weight:500;">
        Creating your perfect match...
      </div>

    </div>
  `;

  setTimeout(callback, 2000);
}

/* SHOW PRODUCT WITH FADE-IN */
function showProduct(name, url){
  options.innerHTML="";
  question.innerText="Your Sunscreen Match";

  // Extract handle safely
  let handle = url.split("/products/")[1];
  if(handle.includes("?")) handle = handle.split("?")[0];
  if(handle.endsWith("/")) handle = handle.slice(0, -1);
  handle = decodeURIComponent(handle);

  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {

      let image = "";
      if(product.images && product.images.length > 0){
        image = product.images[0];
        if(image.startsWith("//")) image = "https:" + image;
      }

      // Centered div with fade-in
      const imgHTML = image ? `<img src="${image}" alt="${name}" class="fade-in" />` : "";

      result.innerHTML = `
        <div style="display:flex;flex-direction:column;align-items:center;">
          ${imgHTML}
          <h3>${name}</h3>
          <a href="${url}">View Product</a>
        </div>
      `;

      // Trigger fade-in
      const imgEl = result.querySelector("img");
      if(imgEl){
        imgEl.style.opacity = 0;
        imgEl.style.transition = "opacity 0.6s ease, transform 0.4s ease";
        setTimeout(() => { imgEl.style.opacity = 1; }, 50);
      }
    })
    .catch(err => {
      console.error("Product fetch error:", err);
      result.innerHTML = `
        <h3>${name}</h3>
        <a href="${url}">View Product</a>
      `;
    });
}